module.exports = __webpack_public_path__ + "static/img/panel_bg.f21f17e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/backgrounds/panel_bg.png
// module id = AtL5
// module chunks = 31